// apps/web/src/components/landing-v2/proofs/PromiseCard.tsx
/** Theme 04 / What's coming — full-width copy + decorative mark.
 *  Aspirational growth, no specific cadence promises. */
export function PromiseCard() {
  return (
    <div
      className="absolute inset-0 grid items-center gap-5 px-6 py-5"
      style={{ gridTemplateColumns: 'minmax(0, 1fr) auto' }}
    >
      <div>
        <span className="inline-flex w-fit items-center rounded-pill border border-gold-light-legacy/30 bg-gold-light-legacy/[0.14] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-gold-light-legacy">
          What&apos;s coming
        </span>
        <div
          className="mt-2 font-display text-text-primary"
          style={{ fontSize: '1.15rem', lineHeight: 1.2 }}
        >
          More decks, more creators —{' '}
          <em className="italic">chosen with care.</em>
        </div>
        <p
          className="mt-1.5 text-text-secondary"
          style={{ fontSize: '0.82rem', maxWidth: '56ch' }}
        >
          We&apos;re bringing new creators and decks into the circle as we grow — each one
          chosen with care, never churned out to hit a number.
        </p>
      </div>
      <div className="flex items-center gap-1.5">
        <span
          className="font-display italic leading-none text-gold-light-legacy"
          style={{ fontSize: '2.6rem' }}
        >
          ✦
        </span>
        <div
          className="text-[10px] uppercase text-text-muted"
          style={{ letterSpacing: '0.22em', maxWidth: '12ch', lineHeight: 1.3 }}
        >
          the circle keeps growing
        </div>
      </div>
    </div>
  )
}
